import React from 'react';
import { DY_COOKIES_UPDATE_PATH, isBrowser } from '@packages/common';

// DY need time to set cookie
const DY_INITIAL_SET_TIMEOUT = 5000;

export const DYCookieRenewer: React.FC = ({ children }) => {
  React.useEffect(() => {
    if (!isBrowser() || document.cookie.includes('_dyid_server')) {
      return;
    }
    setTimeout(async () => {
      if (!document.cookie.includes('_dyid')) {
        return;
      }
      try {
        await fetch(DY_COOKIES_UPDATE_PATH, {
          headers: {
            'Content-Type': 'text/javascript',
          },
        });
      } catch (error) {
        console.error('renew DY cookie error', error);
      }
    }, DY_INITIAL_SET_TIMEOUT);
  });

  return <>{children}</>;
};
